import { Theme } from "@mui/material";

const HALE_NAVY = '#0b2545';
const HALE_NAVY_SOFT = '#122e52';
const HALE_GOLD_LIGHT = '#f6efd8';

const getTextColor = (isHaleBrand: boolean) =>
  isHaleBrand ? HALE_NAVY : 'var(--Neutral-Black, #1A1A1A)';

export const styles = (theme: Theme, isHaleBrand = false) => ({
  bannerWrapper: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    width: 'calc(100% - 14rem)',
    marginLeft: 'auto',
    padding: '.875rem .5rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    background: isHaleBrand
      ? HALE_GOLD_LIGHT
      : 'linear-gradient(180deg, #FEE493 -18.5%, #FDC517 161.55%)',
    zIndex: 1000,
    '@media(max-width: 1365px)': {
      width: '95%',
      marginLeft: '5%',
    },
    '@media(max-width: 1024px)': {
      padding: '.75rem .5rem',
    },
    '@media(max-width: 768px)': {
      padding: '.625rem .375rem',
      width: '100%',
      marginLeft: 0,
    },
    '@media(max-width: 480px)': {
      padding: '.5rem .25rem',
      width: '100%',
      marginLeft: 0,
    },
  },
  bannerContent: {
    width: '100%',
    maxWidth: '1440px',
    display: 'flex',
    justifyContent: 'space-between',
    margin: '0 auto',
    alignItems: 'center',
    padding: '0 2rem',
    gap: '1rem',
    '@media(max-width: 1024px)': {
      padding: '0 1.5rem',
      gap: '0.75rem',
    },
    '@media(max-width: 768px)': {
      padding: '0 1rem',
      gap: '0.5rem',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    '@media(max-width: 480px)': {
      padding: '0 0.75rem',
      gap: '0.5rem',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
  },

  bannerLightHeading: {
    overflow: 'hidden',
    color: getTextColor(isHaleBrand),
    textOverflow: 'ellipsis',
    fontFamily: 'Manrope',
    fontSize: '1rem',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: 'normal',
    '@media(max-width: 768px)': {
      fontSize: '0.875rem',
    },
    '@media(max-width: 480px)': {
      fontSize: '0.75rem',
    },
  },
  bannerDarkHeading: {
    overflow: 'hidden',
    color: getTextColor(isHaleBrand),
    textOverflow: 'ellipsis',
    fontFamily: 'Poppins',
    fontSize: '1.25rem',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: 'normal',
    '@media(max-width: 768px)': {
      fontSize: '1rem',
    },
    '@media(max-width: 480px)': {
      fontSize: '0.875rem',
    },
  },

  timeLeftText: {
    overflow: 'hidden',
    color: getTextColor(isHaleBrand),
    textOverflow: 'ellipsis',
    fontFamily: 'Manrope',
    fontSize: '1rem',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: 'normal',
    whiteSpace: 'nowrap',
    '@media(max-width: 768px)': {
      fontSize: '0.875rem',
    },
    '@media(max-width: 480px)': {
      fontSize: '0.75rem',
    },
  },

  timeDividorDot: {
    overflow: 'hidden',
    color: getTextColor(isHaleBrand),
    textAlign: 'center',
    textOverflow: 'ellipsis',
    fontFamily: 'Manrope',
    fontSize: '1rem',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: 'normal',
    '@media(max-width: 768px)': {
      fontSize: '0.875rem',
    },
    '@media(max-width: 480px)': {
      fontSize: '0.75rem',
    },
  },


  iconBox: {
    background: isHaleBrand
      ? `linear-gradient(0deg, ${HALE_NAVY} 0%, ${HALE_NAVY_SOFT} 100%)`
      : 'linear-gradient(0deg, #000 0%, #555454 100%)',
    color: theme.palette.error.main,
    borderRadius: '50%',
    p: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '2.5rem',
    minHeight: '2.5rem',
    '@media(max-width: 768px)': {
      minWidth: '2rem',
      minHeight: '2rem',
      padding: '0.5rem',
      '& img': {
        width: '1rem',
        height: '1rem',
      },
    },
    '@media(max-width: 480px)': {
      minWidth: '1.75rem',
      minHeight: '1.75rem',
      padding: '0.375rem',
      '& img': {
        width: '0.875rem',
        height: '0.875rem',
      },
    },
  },
  timeStack: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '.38rem',
    flexWrap: 'wrap',
    '@media(max-width: 768px)': {
      gap: '.25rem',
    },
    '@media(max-width: 480px)': {
      gap: '.2rem',
    },
  },
  timeValueBox: {
    background: isHaleBrand ? 'rgba(255, 255, 255, 0.65)' : 'rgba(255, 255, 255, 0.55)',
    borderRadius: '.5rem',
    display: 'flex',
    width: '3.5rem',
    padding: '0.25rem 0rem',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '-0.375rem',
    overflow: 'hidden',
    color: getTextColor(isHaleBrand),
    textAlign: 'center',
    textOverflow: 'ellipsis',
    fontFamily: 'Manrope',
    fontSize: '0.75rem',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: 'normal',
    '@media(max-width: 768px)': {
      width: '3rem',
      padding: '0.2rem 0rem',
      fontSize: '0.625rem',
    },
    '@media(max-width: 480px)': {
      width: '2.5rem',
      padding: '0.15rem 0rem',
      fontSize: '0.5rem',
      borderRadius: '.375rem',
    },
  },
  timeValue: {
    color: getTextColor(isHaleBrand),
    textAlign: 'center',
    fontFamily: 'Manrope',
    fontSize: '1.25rem',
    fontStyle: 'normal',
    fontWeight: 800,
    letterSpacing: '-0.03rem',
    '@media(max-width: 768px)': {
      fontSize: '1rem',
      letterSpacing: '-0.02rem',
    },
    '@media(max-width: 480px)': {
      fontSize: '0.875rem',
      letterSpacing: '-0.015rem',
    },
  },

  startTestBtn: {
    display: 'flex',
    padding: '1rem 1.25rem',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '0.5rem',
    borderRadius: '.8rem',
    background: isHaleBrand ? HALE_NAVY : 'var(--Background-Brand, #1a1a1a)',
    color: 'var(--Text-On-Primary, #FFF)',
    textAlign: 'center',
    fontFamily: 'Manrope',
    fontSize: '.9rem',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '1.25rem', /* 125% */
    letterSpacing: '-0.005rem',
    textTransform: 'capitalize',
    whiteSpace: 'nowrap',
    '@media(max-width: 768px)': {
      padding: '0.75rem 1rem',
      fontSize: '0.8rem',
    },
    '@media(max-width: 480px)': {
      padding: '0.625rem 0.875rem',
      fontSize: '0.75rem',
      borderRadius: '.6rem',
    },
    '&:hover': {
      background: isHaleBrand ? '#081a33' : 'var(--Background-Brand, #1a1a1a)',
      color: 'var(--Text-On-Primary, #FFF)',
      boxShadow: 'none',
      filter: 'none',
      // No hover effect, matches normal state.
  },
  },


});
